module.exports = __webpack_public_path__ + "img/product-s9_pic_app@2x.1cd25542.png";